import { styled } from "@mui/material/styles";

export const ContentArea = styled("div")(({ theme }) => ({
  color: theme.custom.colors.mediGray,
  flexGrow: 1,
  background: theme.custom.colors.contentBackground,
  overflow: "auto",
  minHeight: 0,
}));
